export const COLOURS = {
    darkGreen: "#2E4A37",
    green: "#668E68",
    whiteGreen: "#EDF2EE",
    white: "#FFF",
    lightGreen: "#86A27E",
};